import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { isEmailLink, isTelephoneLink, matchExternalLink } from '@/utils/helpers';

export const useNavigate = () => {
  const history = useHistory();

  const navigate = useCallback(
    ({ href = '', openNewWindow = false }) => {
      const isExternalLink =
        (href && matchExternalLink(href)) || isEmailLink(href) || isTelephoneLink(href);

      if (!isExternalLink) {
        history.push(href);
        return;
      }

      if (openNewWindow) {
        window.open(href);
        return;
      }

      window.location = href;
    },
    [history],
  );

  return { navigate };
};
